import { getCookieByName, setCookie } from '../../../../modules/modify-cookies'

const getCookieContent = ({ config, consoleLog }) => {
  if (!config || !config?.cookieName) {
    return false
  }

  // FOR DEBUG:
  //setCookie('stnews-user', '{"email":"philipp.sorio@abc.it"}')

  const cookieContent = getCookieByName(config.cookieName)
  consoleLog('GET COOKIE CONTENT', 'Looking for cookie ' + config.cookieName, 'Ads')

  if (!cookieContent) {
    consoleLog('GET COOKIE CONTENT', 'Cookie ' + config.cookieName + ' empty or not found!', 'Ads')
    return
  }

  const logMessage = ({ key, value }) => {
    consoleLog('GETCOOKIE CONTENT', 'Cookie ' + key + ' found. Value: ' + value, 'Ads')
  }

  if (config.cookieObjectProperty) {
    const cookiePropertyContent = JSON.parse(cookieContent)[config.cookieObjectProperty]
    logMessage({ key: config.cookieObjectProperty, value: cookiePropertyContent })
    return cookiePropertyContent
  }

  logMessage({ key: config.cookieName, value: cookieContent })
  return cookieContent
}

export default getCookieContent
